export default __webpack_public_path__ + "static/media/Screenshot (1077).6d7a5f93.png";